let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("1gkvI")]).then(() => parcelRequire('9MOi4'));